// @flow
import React from 'react';
import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import H2 from '@waglabs/h2';

import { BodyContainer } from '../BodyContainer';
import { ResponsiveIconAndTextBlock } from '../ResponsiveIconAndTextBlock';

type Data = {
  icon: string,
  headingText: string,
  headingTextColor?: string,
  text: string,
};

type Props = {
  data: Data[],
  sectionTitle: string,
};

export const HowItWorks = ({
  data,
  sectionTitle,
}: Props) => (
  <Flex
    alignItems="center"
    boxSizing="border-box"
    flexDirection="column"
    justifyContent="center"
    pb={2}
    px={[0, 4]}
    width={1}
  >
    <BodyContainer>
      <H2
        color="medGray"
        fontFamily="body"
        fontSize={[7, 7, 8, 10]}
        fontWeight="bold"
        mb={[3, 4, 4, 5]}
      >
        {sectionTitle}
      </H2>
      <Flex
        boxSizing="border-box"
        flexDirection={['column', 'row']}
        justifyContent="center"
        mb={[0, 3]}
        width={1}
      >
        {data.map(item => (
          <Box
            key={item.icon}
            width={1}
          >
            <ResponsiveIconAndTextBlock
              headingText={item.headingText}
              headingTextColor={item.headingTextColor}
              icon={item.icon}
              text={item.text}
            />
          </Box>
        ))}
      </Flex>
    </BodyContainer>
  </Flex>
);
